export default function seleccionarPoliza(seguro) {
	if (!seguro) return undefined;
	return seguro.tipo === "paqueteria"
		? seguro.poliza_hover || seguro.poliza
		: seguro.poliza;
}
